import React from 'react';
import { formatCurrency } from '../../../../../../../../../../utils/functions';
import './SalesMetrics.scss';

interface SalesMetricsProps {
  netSales: number;
  totalTip: number;
  totalDiscounts: number;
  validReceiptCount: number;
  avgTicket: number;
  avgTicketPP?: number;
  totalPeopleServed?: number;
}

const TAX_RATE = 0.19; // 19% IVA for Chile

const SalesMetrics: React.FC<SalesMetricsProps> = ({
  netSales,
  totalTip,
  totalDiscounts,
  validReceiptCount,
  avgTicket,
  avgTicketPP,
  totalPeopleServed
}) => {
  const calculateTaxes = (netSalesValue: number): number => {
    const preTaxAmount = netSalesValue / (1 + TAX_RATE);
    return netSalesValue - preTaxAmount;
  };

  const calculatePreTaxSales = (netSalesValue: number): number => {
    return netSalesValue / (1 + TAX_RATE);
  };

  const preTaxSales = calculatePreTaxSales(netSales);
  const taxes = calculateTaxes(netSales);
  const totalWithTip = netSales + totalTip;

  return (
    <>
      {/* Main Sales Metrics */}
      <div className="sb-section">
        <div className="sb-row">
          <span className="sb-label">Total Venta (con propina)</span>
          <span className="sb-value">{formatCurrency(totalWithTip)}</span>
        </div>
        <div className="sb-row">
          <span className="sb-label">Total Descuentos</span>
          <span className="sb-value">{formatCurrency(totalDiscounts)}</span>
        </div>
        <div className="sb-row">
          <span className="sb-label">Total Venta Bruta</span>
          <span className="sb-value">{formatCurrency(netSales)}</span>
        </div>
        <div className="sb-row">
          <span className="sb-label">Impuestos</span>
          <span className="sb-value">{formatCurrency(taxes)}</span>
        </div>
        <div className="sb-row strong">
          <span className="sb-label">Venta Sin Impuestos</span>
          <span className="sb-value">{formatCurrency(preTaxSales)}</span>
        </div>
      </div>

      {/* Additional Metrics */}
      <div className="sb-section">
        <div className="sb-row">
          <span className="sb-label">Número de Recibos</span>
          <span className="sb-value">{validReceiptCount}</span>
        </div>
        <div className="sb-row">
          <span className="sb-label">Ticket Promedio</span>
          <span className="sb-value">{formatCurrency(avgTicket)}</span>
        </div>
        {avgTicketPP != null && avgTicketPP > 0 && (
          <div className="sb-row">
            <span className="sb-label">Ticket Promedio por Persona</span>
            <span className="sb-value">{formatCurrency(avgTicketPP)}</span>
          </div>
        )}
        {totalPeopleServed != null && totalPeopleServed > 0 && (
          <div className="sb-row">
            <span className="sb-label">Personas Atendidas</span>
            <span className="sb-value">{totalPeopleServed}</span>
          </div>
        )}
        <div className="sb-row">
          <span className="sb-label">Número de Órdenes</span>
          <span className="sb-value">{validReceiptCount}</span>
        </div>
        <div className="sb-row">
          <span className="sb-label">Propinas Recaudadas</span>
          <span className="sb-value">{formatCurrency(totalTip)}</span>
        </div>
        <div className="sb-row">
          <span className="sb-label">Total Vueltos</span>
          <span className="sb-value">{formatCurrency(0)}</span>
        </div>
      </div>
    </>
  );
};

export default SalesMetrics;
